import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode,
} from 'react';
import {
  HomeLoanData,
  CarData,
  EmergencyData,
  EducationData,
  SavingsData,
  DownPaymentData,
  WeddingData,
  VacationData,
  AdvanceVacationData,
  AdvanceDownPaymentData,
  AdvanceSavingsData,
  AdvanceEducationData,
  AdvanceEmergencyData,
  AdvanceCarData,
  AdvanceRetirementData,
  AdvanceWeddingData,
  GoalPlannerState,
  GoalPlannerContextType,
  Users,
  AdditionalSource,
  RetirementData,
  AdvanceHomeData,
} from './types';

const defaultAdvanceDownPaymentData: AdvanceDownPaymentData = {
  sum: '',
  amount: '',
  years: '',
  returns: '',
  current_savings: '',
  Additional_costs: {
    sum: '',
    registration_fees: '',
    loan_processing_fees: '',
  },
};
const defaultadvanceVacationData: AdvanceVacationData = {
  amount: '',
  years: '',
  returns: '',
  sum1: '',
  travel: {
    sum: '',
    tickets: '',
    local_transportation: '',
  },
  accommodation: {
    sum: '',
    resort: '',
    rentals: '',
  },
  food_and_beverages: {
    sum: '',
    meal_budget: '',
    special: '',
  },
  activities: {
    sum: '',
    tours: '',
    entertainment: '',
  },
  miscellaneous: {
    sum: '',
    travel_insurance: '',
    shopping_and_souvenirs: '',
    emergency_funds: '',
  },
};
const defaultadvanceSavingsData: AdvanceSavingsData = {
  amount: '',
  sum: '',
  years: '',
  returns: '',
  current_savings: '',
};
const defaultadvanceEducationData: AdvanceEducationData = {
  sum: '',
  amount: '',
  years: '',
  returns: '',
  Additional_costs: {
    sum: '',
    tuition_fees: '',
    hostel: '',
    books: '',
    expense: '',
  },
};
const defaultadvanceEmergencyData: AdvanceEmergencyData = {
  amount: '',
  sum: '',
  years: '',
  returns: '',
  current_savings: '',
};
const defaultadvanceCarData: AdvanceCarData = {
  sum: '',
  amount: '',
  years: '',
  returns: '',
  down_payment: '',
  Additional_costs: {
    sum: '',
    insurance: '',
    registration_fees: '',
    maintenance_budget: '',
  },
};
const defaultadvanceHomeData: AdvanceHomeData = {
  sum: '',
  amount: '',
  years: '',
  returns: '',
  down_payment: '',
  Additional_costs: {
    sum: '',
    registration_fees: '',
    interior_design: '',
    moving_expenses: '',
  },
};
const defaultadvanceData: AdvanceRetirementData = {
  sum1: '',
  amount: '',
  years: '',
  returns: '',
  current_savings: '',
  expenses: {
    sum: '',
    housing: '',
    leisure: '',
    medical_costs: '',
    daily_living_expenses: '',
  },
};
const defaultData: AdvanceWeddingData = {
  guest: '',
  bride_and_groom: {
    sum: '',
    bride_dress_cost: '',
    groom_dress_cost: '',
    jewellery: '',
    wedding_rings: '',
  },
  subtractors: {
    sum: '',
    wedding_stationary: '',
    photography: '',
    florist: '',
    planner: '',
  },
  venue: {
    sum: '',
    venue_cost: '',
    catering: '',
    rehearsal_dinner: '',
    cake: '',
    drinks: '',
    dj: '',
  },
  custom: {
    sum: '',
    custom1: '',
    custom2: '',
    custom3: '',
    custom4: '',
  },
  ceremony: {
    sum: '',
    ceremony_site: '',
    officiant: '',
  },
  transport: {
    sum: '',
    hotel: '',
    transportation: '',
  },
};
const GoalPlannerContext = createContext<GoalPlannerContextType | undefined>(
  undefined,
);

const GoalPlannerProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [goalPlannerState, setGoalPlannerState] = useState<GoalPlannerState>({
    activeStep: 1,
    activeTab: 'input',
    years: 0,
    totalAmount: 0,
    totalExpense: 0,
    name: '',

    isModalOpen: false, // Initialize modal visibility state
    currentGoal: {
      name: '',
      description: 'This is retirement ',
      targetAmount: 10000,
      dueDate: '',
      details: {
        age: '26',
        retire: '26',
        type: '',
        goal_for: '',
        monthly_income: '0',
        additional_Sources: [{ source: '', amount: 0 }],
        expense: '',
        savings: '',
        retireOption: '',
        preRetire: '15.0',
        postRetire: '5.0',
        inflation: '6.0',
        expectedLife: '85',
        users: [],
      },
    },
  });
  const [advanceDownPaymentData, setAdvanceDownPaymentData] = useState(
    defaultAdvanceDownPaymentData,
  );
  const setAdvanceDownPaymentamt = (amt: string) => {
    setAdvanceDownPaymentData(prevStep => ({
      ...prevStep,
      amount: amt,
    }));
  };
  const setMode = () => {
    setSwitch(false);
  };
  const setAdvanceDownPaymentyrs = (amt: string) => {
    setAdvanceDownPaymentData(prevStep => ({
      ...prevStep,
      years: amt,
    }));
  };
  const setAdvanceDownPaymentSavings = (amt: string) => {
    setAdvanceDownPaymentData(prevStep => ({
      ...prevStep,
      current_savings: amt,
    }));
  };
  const setAdvanceDownPaymentreturns = (amt: string) => {
    setAdvanceDownPaymentData(prevStep => ({
      ...prevStep,
      returns: amt,
    }));
  };
  const setAdvanceDownPaymentsum = (amt: string) => {
    setAdvanceDownPaymentData(prevStep => ({
      ...prevStep,
      sum: amt,
    }));
  };
  const setAdvanceDownAdditionalsum = (
    category: keyof AdvanceDownPaymentData,
    amt: string,
  ) => {
    setAdvanceDownPaymentData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        sum: amt,
      },
    }));
  };
  const setAdvanceDownAdditionalfees = (
    category: keyof AdvanceDownPaymentData,
    amt: string,
  ) => {
    setAdvanceDownPaymentData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        registration_fees: amt,
      },
    }));
  };
  const setAdvanceDownAdditionalloan = (
    category: keyof AdvanceDownPaymentData,
    amt: string,
  ) => {
    setAdvanceDownPaymentData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        loan_processing_fees: amt,
      },
    }));
  };
  const [advanceSavingsData, setAdvanceSavingsData] = useState(
    defaultadvanceSavingsData,
  );
  const setAdvancesavingsamt = (amt: string) => {
    setAdvanceSavingsData(prevStep => ({
      ...prevStep,
      amount: amt,
    }));
  };
  const setAdvancesavingsyrs = (amt: string) => {
    setAdvanceSavingsData(prevStep => ({
      ...prevStep,
      years: amt,
    }));
  };
  const setAdvancesavingsreturns = (amt: string) => {
    setAdvanceSavingsData(prevStep => ({
      ...prevStep,
      returns: amt,
    }));
  };
  const setAdvancesavingssum = (amt: string) => {
    setAdvanceSavingsData(prevStep => ({
      ...prevStep,
      sum: amt,
    }));
  };
  const setAdvancesavings = (amt: string) => {
    setAdvanceSavingsData(prevStep => ({
      ...prevStep,
      current_savings: amt,
    }));
  };

  const [advanceEducationData, setAdvanceEducationData] = useState(
    defaultadvanceEducationData,
  );
  const setAdvanceEducationamt = (amt: string) => {
    setAdvanceEducationData(prevStep => ({
      ...prevStep,
      amount: amt,
    }));
  };
  const setAdvanceEducationyrs = (amt: string) => {
    setAdvanceEducationData(prevStep => ({
      ...prevStep,
      years: amt,
    }));
  };
  const setAdvanceEducationreturns = (amt: string) => {
    setAdvanceEducationData(prevStep => ({
      ...prevStep,
      returns: amt,
    }));
  };
  const setAdvanceEducationsum = (amt: string) => {
    setAdvanceEducationData(prevStep => ({
      ...prevStep,
      sum: amt,
    }));
  };
  const setAdvanceEducationAdditionalsum = (
    category: keyof AdvanceEducationData,
    amt: string,
  ) => {
    setAdvanceEducationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        sum: amt,
      },
    }));
  };
  const setAdvanceEducationAdditionalfees = (
    category: keyof AdvanceEducationData,
    amt: string,
  ) => {
    setAdvanceEducationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        tuition_fees: amt,
      },
    }));
  };
  const setAdvanceEducationAdditionalhostel = (
    category: keyof AdvanceEducationData,
    amt: string,
  ) => {
    setAdvanceEducationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        hostel: amt,
      },
    }));
  };
  const setAdvanceEducationAdditionalbook = (
    category: keyof AdvanceEducationData,
    amt: string,
  ) => {
    setAdvanceEducationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        books: amt,
      },
    }));
  };
  const setAdvanceEducationAdditionalexpense = (
    category: keyof AdvanceEducationData,
    amt: string,
  ) => {
    setAdvanceEducationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        expense: amt,
      },
    }));
  };
  const [advanceEmergencyData, setAdvanceEmergencyData] = useState(
    defaultadvanceEmergencyData,
  );
  const setAdvanceEmergencyamt = (amt: string) => {
    setAdvanceEmergencyData(prevStep => ({
      ...prevStep,
      amount: amt,
    }));
  };
  const setAdvanceEmergencyyrs = (amt: string) => {
    setAdvanceEmergencyData(prevStep => ({
      ...prevStep,
      years: amt,
    }));
  };
  const setAdvanceEmergencyreturns = (amt: string) => {
    setAdvanceEmergencyData(prevStep => ({
      ...prevStep,
      returns: amt,
    }));
  };
  const setAdvanceEmergencysum = (amt: string) => {
    setAdvanceEmergencyData(prevStep => ({
      ...prevStep,
      sum: amt,
    }));
  };
  const setAdvanceEmergencysavings = (amt: string) => {
    setAdvanceEmergencyData(prevStep => ({
      ...prevStep,
      current_savings: amt,
    }));
  };
  const [advanceCarData, setAdvanceCarData] = useState(defaultadvanceCarData);
  const setAdvanceCaramt = (amt: string) => {
    setAdvanceCarData(prevStep => ({
      ...prevStep,
      amount: amt,
    }));
  };
  const setAdvanceCaryrs = (amt: string) => {
    setAdvanceCarData(prevStep => ({
      ...prevStep,
      years: amt,
    }));
  };
  const setAdvanceCarreturns = (amt: string) => {
    setAdvanceCarData(prevStep => ({
      ...prevStep,
      returns: amt,
    }));
  };
  const setAdvanceCardown = (amt: string) => {
    setAdvanceCarData(prevStep => ({
      ...prevStep,
      down_payment: amt,
    }));
  };
  const setAdvanceCarsum = (amt: string) => {
    setAdvanceCarData(prevStep => ({
      ...prevStep,
      sum: amt,
    }));
  };
  const setAdvanceCarAdditionalsum = (
    category: keyof AdvanceCarData,
    amt: string,
  ) => {
    setAdvanceCarData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        sum: amt,
      },
    }));
  };

  const setAdvanceCarAdditionalfees = (
    category: keyof AdvanceCarData,
    amt: string,
  ) => {
    setAdvanceCarData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        registration_fees: amt,
      },
    }));
  };
  const setAdvanceCarAdditionaldesign = (
    category: keyof AdvanceCarData,
    amt: string,
  ) => {
    setAdvanceCarData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        insurance: amt,
      },
    }));
  };
  const setAdvanceCarAdditionalexpense = (
    category: keyof AdvanceCarData,
    amt: string,
  ) => {
    setAdvanceCarData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        maintenance_budget: amt,
      },
    }));
  };
  const [advanceVacationData, setAdvanceVacationData] = useState(
    defaultadvanceVacationData,
  );
  const setAdvancevacationTravelsum = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        sum: amt,
      },
    }));
  };
  const setAdvancevacationTravelticket = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        tickets: amt,
      },
    }));
  };
  const setAdvancevacationTravellocal = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        local_transportation: amt,
      },
    }));
  };
  const setAdvancevacationaccommodationsum = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        sum: amt,
      },
    }));
  };
  const setAdvancevacationaccommodationresort = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        resort: amt,
      },
    }));
  };
  const setAdvancevacationaccommodationrrental = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        rentals: amt,
      },
    }));
  };
  const setAdvancevacationfoodsum = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        sum: amt,
      },
    }));
  };
  const setAdvancevacationfoodmeal = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        meal_budget: amt,
      },
    }));
  };
  const setAdvancevacationfoodspecial = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        special: amt,
      },
    }));
  };
  const setAdvancevacationactivitiessum = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        sum: amt,
      },
    }));
  };
  const setAdvancevacationactivitiestour = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        tours: amt,
      },
    }));
  };
  const setAdvancevacationactivitiesentertainment = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        entertainment: amt,
      },
    }));
  };
  const setAdvancevacationmiscellaneoussum = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        sum: amt,
      },
    }));
  };
  const setAdvancevacationmiscellaneousinsurance = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        travel_insurance: amt,
      },
    }));
  };
  const setAdvancevacationmiscellaneousshopping = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        shopping_and_souvenirs: amt,
      },
    }));
  };
  const setAdvancevacationmiscellaneousfunds = (
    category: keyof AdvanceVacationData,
    amt: string,
  ) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        emergency_funds: amt,
      },
    }));
  };
  const setAdvancevacationamt = (amt: string) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      amount: amt,
    }));
  };
  const setAdvancevacationyrs = (amt: string) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      years: amt,
    }));
  };
  const setAdvancevacationreturns = (amt: string) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      returns: amt,
    }));
  };
  const setAdvancevacationsum = (amt: string) => {
    setAdvanceVacationData(prev => ({
      ...prev,
      sum1: amt,
    }));
  };
  const [advanceHomeData, setAdvanceHomeData] = useState(
    defaultadvanceHomeData,
  );
  const setAdvanceHomeAdditionalfee = (
    category: keyof AdvanceHomeData,
    amt: string,
  ) => {
    setAdvanceHomeData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        registration_fees: amt,
      },
    }));
  };
  const setAdvanceHomesum = (amt: string) => {
    setAdvanceHomeData(prev => ({
      ...prev,
      sum: amt,
    }));
  };
  const setAdvanceHomeAdditionaldesign = (
    category: keyof AdvanceHomeData,
    amt: string,
  ) => {
    setAdvanceHomeData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        interior_design: amt,
      },
    }));
  };
  const setAdvanceHomeAdditionalsum = (
    category: keyof AdvanceHomeData,
    amt: string,
  ) => {
    setAdvanceHomeData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        sum: amt,
      },
    }));
  };
  const setAdvanceHomeAdditionalexp = (
    category: keyof AdvanceHomeData,
    amt: string,
  ) => {
    setAdvanceHomeData(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        moving_expenses: amt,
      },
    }));
  };
  const setAdvanceHomeamt = (amt: string) => {
    setAdvanceHomeData(prev => ({
      ...prev,
      amount: amt,
    }));
  };
  const setAdvanceHomeyrs = (amt: string) => {
    setAdvanceHomeData(prev => ({
      ...prev,
      years: amt,
    }));
  };
  const setAdvanceHomereturns = (amt: string) => {
    setAdvanceHomeData(prev => ({
      ...prev,
      returns: amt,
    }));
  };
  const setAdvanceHomedown = (amt: string) => {
    setAdvanceHomeData(prev => ({
      ...prev,
      down_payment: amt,
    }));
  };
  const [monthlySavings, setmonthly] = useState('0');
  const [downPayment, setdownPayment] = useState<DownPaymentData>({
    budget: '',
    year: '',
    return: '',
    frequency: 'monthly',
  });
  const [savings, setSavings] = useState<SavingsData>({
    budget: '',
    year: '',
    return: '',
    frequency: 'monthly',
  });
  const [educationLoan, seteducationLoan] = useState<EducationData>({
    budget: '',
    year: '',
    return: '',
    frequency: 'monthly',
  });
  const [emergencyLoan, setemergencyLoan] = useState<EmergencyData>({
    budget: '',
    year: '',
    return: '',
    frequency: 'monthly',
  });
  const [carLoan, setcarLoan] = useState<CarData>({
    budget: '',
    year: '',
    return: '',
    frequency: 'monthly',
  });
  const [homeLoan, sethomeLoan] = useState<HomeLoanData>({
    budget: '',
    year: '',
    return: '',
    frequency: 'monthly',
  });
  const [retirement, setretirement] = useState<RetirementData>({
    budget: '',
    year: '',
    return: '',
    frequency: 'monthly',
  });
  const [wedding, setwedding] = useState<WeddingData>({
    budget: '',
    year: '',
    return: '',
    frequency: 'monthly',
  });
  const [vacation, setvacation] = useState<VacationData>({
    budget: '',
    year: '',
    return: '',
    frequency: 'monthly',
  });
  const [advanceRetirement, setAdvanceRetirement] =
    useState<AdvanceRetirementData>(defaultadvanceData);
  const setAdvanceRetirementamt = (amt: string) => {
    setAdvanceRetirement(prevStep => ({
      ...prevStep,
      amount: amt,
    }));
  };
  const setAdvanceRetirementsum1 = (amt: string) => {
    setAdvanceRetirement(prevStep => ({
      ...prevStep,
      sum1: amt,
    }));
  };
  const setAdvanceRetirementcurrentsavings = (amt: string) => {
    setAdvanceRetirement(prevStep => ({
      ...prevStep,
      current_savings: amt,
    }));
  };
  const setAdvanceRetirementyrs = (yrs: string) => {
    setAdvanceRetirement(prevStep => ({
      ...prevStep,
      years: yrs,
    }));
  };
  const setAdvanceRetirementreturns = (returns: string) => {
    setAdvanceRetirement(prevStep => ({
      ...prevStep,
      returns: returns,
    }));
  };
  const setAdvanceRetirementHousing = (
    category: keyof AdvanceRetirementData,
    amt: string,
  ) => {
    setAdvanceRetirement(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        housing: amt,
      },
    }));
  };
  const setAdvanceRetirementdaily = (
    category: keyof AdvanceRetirementData,
    amt: string,
  ) => {
    setAdvanceRetirement(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        daily_living_expenses: amt,
      },
    }));
  };
  const setAdvanceRetirementmedicalcost = (
    category: keyof AdvanceRetirementData,
    amt: string,
  ) => {
    setAdvanceRetirement(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        medical_costs: amt,
      },
    }));
  };
  const setAdvanceRetirementLeisure = (
    category: keyof AdvanceRetirementData,
    amt: string,
  ) => {
    setAdvanceRetirement(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        leisure: amt,
      },
    }));
  };
  const setAdvanceRetirementexpensesum = (
    category: keyof AdvanceRetirementData,
    amt: string,
  ) => {
    setAdvanceRetirement(prev => ({
      ...prev,
      [category]: {
        ...(typeof prev[category] === 'object' ? prev[category] : {}),
        sum: amt,
      },
    }));
  };
  const [advanceData, setAdvanceData] =
    useState<AdvanceWeddingData>(defaultData);
  const setMonthly = (amt: string) => {
    setmonthly(amt);
  };
  const setSum = (
    category: keyof Omit<AdvanceWeddingData, 'guest'>,
    amt: string,
  ) => {
    setAdvanceData(prev => ({
      ...prev,
      [category]: {
        ...(prev[category] as Record<string, string>), // Ensure it's treated as an object
        sum: amt, // Update the sum field
      },
    }));
  };
  const [switchMode, setSwitch] = useState<boolean>(false);
  const setretirementAmount = (amt: string) => {
    setretirement(prevState => ({
      ...prevState,
      budget: amt,
    }));
  };
  const setretirementTime = (yrs: string) => {
    setretirement(prevState => ({
      ...prevState,
      year: yrs,
    }));
  };
  const setretirementreturns = (returns: string) => {
    setretirement(prevState => ({
      ...prevState,
      return: returns,
    }));
  };
  const setHomeAmount = (amt: string) => {
    sethomeLoan(prevState => ({
      ...prevState,
      budget: amt,
    }));
  };
  const setHomeTime = (yrs: string) => {
    sethomeLoan(prevState => ({
      ...prevState,
      year: yrs,
    }));
  };
  const setHomereturns = (returns: string) => {
    sethomeLoan(prevState => ({
      ...prevState,
      return: returns,
    }));
  };
  const setCarAmount = (amt: string) => {
    setcarLoan(prevState => ({
      ...prevState,
      budget: amt,
    }));
  };
  const setCarTime = (yrs: string) => {
    setcarLoan(prevState => ({
      ...prevState,
      year: yrs,
    }));
  };
  const setCarreturns = (returns: string) => {
    setcarLoan(prevState => ({
      ...prevState,
      return: returns,
    }));
  };
  const setEmergencyAmount = (amt: string) => {
    setemergencyLoan(prevState => ({
      ...prevState,
      budget: amt,
    }));
  };
  const setEmergencyTime = (yrs: string) => {
    setemergencyLoan(prevState => ({
      ...prevState,
      year: yrs,
    }));
  };
  const setEmergencyreturns = (returns: string) => {
    setemergencyLoan(prevState => ({
      ...prevState,
      return: returns,
    }));
  };
  const setEducationAmount = (amt: string) => {
    seteducationLoan(prevState => ({
      ...prevState,
      budget: amt,
    }));
  };
  const setEducationTime = (yrs: string) => {
    seteducationLoan(prevState => ({
      ...prevState,
      year: yrs,
    }));
  };
  const setEducationreturns = (returns: string) => {
    seteducationLoan(prevState => ({
      ...prevState,
      return: returns,
    }));
  };
  const setsavingsAmount = (amt: string) => {
    setSavings(prevState => ({
      ...prevState,
      budget: amt,
    }));
  };
  const setsavingsTime = (yrs: string) => {
    setSavings(prevState => ({
      ...prevState,
      year: yrs,
    }));
  };
  const setsavingsreturns = (returns: string) => {
    setSavings(prevState => ({
      ...prevState,
      return: returns,
    }));
  };
  const setdownPaymentAmount = (amt: string) => {
    setdownPayment(prevState => ({
      ...prevState,
      budget: amt,
    }));
  };
  const setdownPaymentTime = (yrs: string) => {
    setdownPayment(prevState => ({
      ...prevState,
      year: yrs,
    }));
  };
  const setdownPaymentreturns = (returns: string) => {
    setdownPayment(prevState => ({
      ...prevState,
      return: returns,
    }));
  };
  const setweddingamt = (amt: string) => {
    setwedding(prevState => ({
      ...prevState,
      budget: amt,
    }));
  };

  const setweddingduration = (yrs: string) => {
    setwedding(prevState => ({
      ...prevState,
      year: yrs,
    }));
  };
  const setvacationDuration = (yrs: string) => {
    setvacation(prevState => ({
      ...prevState,
      year: yrs,
    }));
  };
  const setvacationreturns = (returns: string) => {
    setvacation(prevState => ({
      ...prevState,
      return: returns,
    }));
  };
  const setweddingreturns = (returns: string) => {
    setwedding(prevState => ({
      ...prevState,
      return: returns,
    }));
  };
  const setAmount = (amt: string) => {
    setwedding(prev => ({
      ...prev,
      budget: amt,
    }));
  };
  const setvacationAmount = (amt: string) => {
    setvacation(prev => ({
      ...prev,
      budget: amt,
    }));
  };
  const setswitch = () => {
    setSwitch(prev => !prev);
  };
  const nextStep = () => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      activeStep: Math.min(prevState.activeStep + 1, 5),
    }));
  };

  const prevStep = () => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      activeStep: Math.max(prevState.activeStep - 1, 1),
    }));
  };

  const setActiveTab = useCallback((tab: 'input' | 'output') => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      activeTab: tab,
    }));
  }, []);

  const toggleModal = () => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      isModalOpen: !prevState.isModalOpen, // Toggle modal visibility
    }));
  };
  const setGoalName = (name: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal, // Spread existing properties to retain their values
        name,
      } as GoalPlannerState['currentGoal'], // Ensure type safety
    }));
  };
  const setGoalType = (type: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          type, // Update only the type field inside details
        },
      },
    }));
  };
  const setGoalFor = (goalFor: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          goal_for: goalFor, // Update only the goal_for field inside details
        },
      },
    }));
  };
  const setDueDate = (retire: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal, // Spread the previous currentGoal to keep other properties intact
        dueDate: retire, // Update the dueDate
      },
    }));
  };
  const setname = (username: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal, // Spread the previous currentGoal to keep other properties intact
        name: username, // Update the dueDate
      },
    }));
  };
  const setGoalAge = (age: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          age: age, // Update only the goal_for field inside details
        },
      },
    }));
  };
  const setRetireAge = (age: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          retire: age, // Update only the goal_for field inside details
        },
      },
    }));
  };
  const setmonthly_income = (income: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          monthly_income: income, // Update only the goal_for field inside details
        },
      },
    }));
  };
  const setexpense = (expens: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          expense: expens, // Update only the goal_for field inside details
        },
      },
    }));
  };
  const setsavings = (saving: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          savings: saving, // Update only the goal_for field inside details
        },
      },
    }));
  };

  const setretireOption = (retireOption: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          retireOption: retireOption, // Update only the goal_for field inside details
        },
      },
    }));
  };
  const setpreRetire = (preretire: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          preRetire: preretire, // Update only the goal_for field inside details
        },
      },
    }));
  };
  const setpostRetire = (preretire: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          preRetire: preretire, // Update only the goal_for field inside details
        },
      },
    }));
  };

  const setinflation = (preretire: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          preRetire: preretire, // Update only the goal_for field inside details
        },
      },
    }));
  };
  const setexpectedLife = (expected: string) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          expectedLife: expected, // Update only the goal_for field inside details
        },
      },
    }));
  };
  const setadditional_Sources = (items: AdditionalSource[]) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          additional_Sources: items, // Now you're passing an array of AdditionalSource
        },
      },
    }));
  };

  const setuser = (users: Users[]) => {
    setGoalPlannerState(prevState => ({
      ...prevState,
      currentGoal: {
        ...prevState.currentGoal,
        details: {
          ...prevState.currentGoal.details,
          users,
        },
      },
    }));
  };

  const contextValue: GoalPlannerContextType = {
    setMode,
    advanceHomeData,
    setAmount,
    switchMode,
    setswitch,
    advanceDownPaymentData,
    setAdvanceDownAdditionalloan,
    setAdvanceDownAdditionalfees,
    setAdvanceDownAdditionalsum,
    setAdvanceDownPaymentreturns,
    setAdvanceDownPaymentamt,
    setAdvanceDownPaymentyrs,
    setAdvanceDownPaymentsum,
    advanceSavingsData,
    setAdvancesavingsamt,
    setAdvancesavingsyrs,
    setAdvancesavingsreturns,
    setAdvancesavingssum,
    setAdvancesavings,
    advanceEducationData,
    setAdvanceEducationsum,
    setAdvanceEducationamt,
    setAdvanceEducationyrs,
    setAdvanceEducationreturns,
    setAdvanceEducationAdditionalsum,
    setAdvanceEducationAdditionalfees,
    setAdvanceEducationAdditionalbook,
    setAdvanceEducationAdditionalhostel,
    setAdvanceEducationAdditionalexpense,
    advanceEmergencyData,
    setAdvanceEmergencyamt,
    setAdvanceEmergencyyrs,
    setAdvanceEmergencyreturns,
    setAdvanceEmergencysum,
    setAdvanceEmergencysavings,
    advanceCarData,
    setAdvanceCaramt,
    setAdvanceCaryrs,
    setAdvanceCarreturns,
    setAdvanceCarsum,
    setAdvanceCarAdditionalsum,
    setAdvanceCarAdditionalfees,
    setAdvanceCarAdditionaldesign,
    setAdvanceCarAdditionalexpense,
    setAdvanceCardown,
    advanceVacationData,
    setAdvancevacationamt,
    setAdvancevacationyrs,
    setAdvancevacationreturns,
    setAdvancevacationsum,
    setAdvancevacationmiscellaneousfunds,
    setAdvancevacationmiscellaneousshopping,
    setAdvancevacationmiscellaneousinsurance,
    setAdvancevacationmiscellaneoussum,
    setAdvancevacationactivitiesentertainment,
    setAdvancevacationactivitiestour,
    setAdvancevacationactivitiessum,
    setAdvancevacationfoodspecial,
    setAdvancevacationfoodmeal,
    setAdvancevacationfoodsum,
    setAdvancevacationaccommodationresort,
    setAdvancevacationaccommodationsum,
    setAdvancevacationTravellocal,
    setAdvancevacationaccommodationrrental,
    setAdvancevacationTravelticket,
    setAdvancevacationTravelsum,
    setAdvanceHomeAdditionalfee,
    setAdvanceHomeAdditionaldesign,
    setAdvanceHomeAdditionalexp,
    setAdvanceHomeamt,
    setAdvanceHomeyrs,
    setAdvanceHomereturns,
    setAdvanceHomedown,
    setAdvanceHomeAdditionalsum,
    setAdvanceHomesum,
    advanceRetirement,
    monthlySavings,
    setAdvanceDownPaymentSavings,
    setSum,
    setMonthly,
    setAdvanceRetirementamt,
    setAdvanceRetirementcurrentsavings,
    setAdvanceRetirementyrs,
    setAdvanceRetirementLeisure,
    setAdvanceRetirementreturns,
    setAdvanceRetirementHousing,
    setAdvanceRetirementdaily,
    setAdvanceRetirementmedicalcost,
    setAdvanceRetirementexpensesum,
    setAdvanceRetirementsum1,
    vacation,
    advanceData,
    retirement,
    homeLoan,
    carLoan,
    emergencyLoan,
    educationLoan,
    savings,
    downPayment,
    setretirementAmount,
    setretirementTime,
    setretirementreturns,
    setHomeAmount,
    setHomeTime,
    setHomereturns,
    setCarAmount,
    setCarTime,
    setCarreturns,
    setEmergencyAmount,
    setEmergencyTime,
    setEmergencyreturns,
    setEducationAmount,
    setEducationTime,
    setEducationreturns,
    setsavingsAmount,
    setsavingsTime,
    setsavingsreturns,
    setdownPaymentAmount,
    setdownPaymentTime,
    setdownPaymentreturns,
    setvacationAmount,
    setvacationDuration,
    setvacationreturns,
    wedding,
    setweddingamt,
    setweddingduration,
    setweddingreturns,
    ...goalPlannerState,
    setGoalPlannerState,
    nextStep,
    prevStep,
    setActiveTab,
    toggleModal, // Include toggleModal in the context value
    setGoalName,
    setGoalType,
    setGoalFor,
    setGoalAge,
    setRetireAge,
    setmonthly_income,
    setadditional_Sources,
    setexpense,
    setretireOption,
    setsavings,
    setpreRetire,
    setpostRetire,
    setinflation,
    setexpectedLife,
    setuser,
    setDueDate,
    setname,
  };

  return (
    <GoalPlannerContext.Provider value={contextValue}>
      {children}
    </GoalPlannerContext.Provider>
  );
};

const useGoalPlanner = (): GoalPlannerContextType => {
  const context = useContext(GoalPlannerContext);
  if (!context) {
    throw new Error('useGoalPlanner must be used within a GoalPlannerProvider');
  }
  return context;
};

export { GoalPlannerProvider, useGoalPlanner };
